import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDroplet = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 2.7 17.66 8.35a8 8 0 1 1-11.31 0z" })
});
export default SvgDroplet;
